import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconListOptions = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path d="M9.5 6H18.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M9.5 12H18.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M9.5 18H18.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M5 6H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M5 12H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M5 18H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  )
}

export default IconListOptions
